const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let gaLoaded = false;

function visitorId() {
  let id = localStorage.getItem("ss_vid");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());
    localStorage.setItem("ss_vid", id);
  }
  return id;
}

function sessionId() {
  let id = sessionStorage.getItem("ss_sid");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());
    sessionStorage.setItem("ss_sid", id);
  }
  return id;
}

function device() {
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

// ---- Google Analytics 4 (loads only if a Measurement ID is configured) ----
export function loadGA() {
  if (gaLoaded || !GA_ID) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  gaLoaded = true;
}

function gaEvent(name, params) {
  if (GA_ID && typeof window.gtag === "function") window.gtag("event", name, params || {});
}

// ---- Unified tracker: sends to our backend AND GA4 ----
async function send(type, extra = {}) {
  try {
    await fetch(`${API}/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitor_id: visitorId(),
        session_id: sessionId(),
        type,
        path: window.location.pathname,
        referrer: document.referrer || "",
        device: device(),
        ...extra,
      }),
      keepalive: true,
    });
  } catch (e) { /* analytics must never break the app */ }
}

export function trackPageView() {
  send("pageview");
  gaEvent("page_view", { page_path: window.location.pathname, page_title: document.title });
}

export function trackEvent(type, label = "") {
  send(type, { label });
  gaEvent(type, { label });
}
